import { DateRange } from '../../../services/equipment/types';

/**
 * Utility functions for date range calculations
 */
export const addDays = (date: Date, days: number) => {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const formatDate = (date: Date) => date.toISOString().split('T')[0];

/**
 * Get default date range (last 90 days)
 */
export const getDefaultDateRange = (): DateRange => {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(endDate.getDate() - 90);
  
  return {
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
  };
};

/**
 * Validate that a date range is valid (start date before or equal to end date)
 */
export const isValidDateRange = (startDate: string, endDate: string): boolean => {
  return startDate <= endDate;
};

/**
 * Format date range for display
 */
export const formatDateRangeForDisplay = (dateRange: DateRange): string => {
  const startDate = new Date(dateRange.startDate);
  const endDate = new Date(dateRange.endDate);
  
  const formatOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  
  return `${startDate.toLocaleDateString('en-US', formatOptions)} - ${endDate.toLocaleDateString('en-US', formatOptions)}`;
};
